import moment from 'moment';

export class State {

    totalStatsDeklaracje: number = 0;
    totalStatsDeklaracjeUpdatedAt: string = '';
    totalStatsDeklaracjeLoading: boolean = false;

    totalStatsPobrania: number = 0;
    totalStatsPobraniaUpdatedAt: string = '';
    totalStatsPobraniaLoading: boolean = false;

    totalStatsUruchomienia: number = 0;
    totalStatsUruchomieniaUpdatedAt: string = '';
    totalStatsUruchomieniaLoading: boolean = false;

    totalStatsDeklaracjeLastYear: number = 0;
    totalStatsDeklaracjeLastYearUpdatedAt: string = '';
    totalStatsDeklaracjeLastYearLoading: boolean = false;

    aggregatedStatsDeklaracjeLoading: boolean = false;
    aggregatedStatsDeklaracjeLastYearLoading: boolean = false;
    aggregatedStatsDeklaracjeDataset: object = {};
    aggregatedStatsDeklaracjeLastYearDataset: object = {};
    aggregatedStatsDeklaracjeDatasets: object = {};
    aggregatedStatsDeklaracjeDateTo: string = moment().format('YYYY-MM-DD');
    aggregatedStatsDeklaracjeUpdatedAt: string = '';

    aggregatedStatsUruchomieniaLoading: boolean = false;
    aggregatedStatsUruchomieniaLastYearLoading: boolean = false;
    aggregatedStatsUruchomieniaDataset: object = {};
    aggregatedStatsUruchomieniaLastYearDataset: object = {};
    aggregatedStatsUruchomieniaDatasets: object = {};
    aggregatedStatsUruchomieniaDateTo: string = moment().format('YYYY-MM-DD');
    aggregatedStatsUruchomieniaUpdatedAt: string = '';

    statsTopOperatingSystemsLoading: boolean = false;
    statsTopOperatingSystemsDataset: object = {};
    statsTopOperatingSystemsUpdatedAt: string = '';

    statsTopBrowsersLoading: boolean = false;
    statsTopBrowsersPage: number = 1;
    statsTopBrowsersCurrentPage: number = 1;
    statsTopBrowsersTotal: number = 0;
    statsTopBrowsersData: object = {};
    statsTopBrowsersAggregatedLoading: boolean = false;
    statsTopBrowsersAggregatedData: object = {};

    statsTopIPLoading: boolean = false;
    statsTopIPPage: number = 1;
    statsTopIPCurrentPage: number = 1;
    statsTopIPTotal: number = 0;
    statsTopIPData: object = {};

    statsTopPobraniaReferersLoading: boolean = false;
    statsTopPobraniaReferersPage: number = 1;
    statsTopPobraniaReferersCurrentPage: number = 1;
    statsTopPobraniaReferersTotal: number = 0;
    statsTopPobraniaReferersData: object = {};

}


